import React, { forwardRef, ForwardedRef } from "react";
import moment from "moment";
import FormField from "@modules/formx-react/FormField";
import DatePicker, { DatePickerProps } from "../DatePicker";

export type DateProps = {
  name: string;
  label?: string;
  DatePickerProps?: Partial<DatePickerProps>;
  utc?: boolean; // no offset in resulting value
  transformValue?: (v: moment.Moment) => Date;
  disabled?: boolean;
  onChangeListener?: (value: any) => void;
  placeholder?: string;
};

export const Date = forwardRef((props: DateProps, ref: ForwardedRef<any>) => {
  const {
    name,
    label,
    DatePickerProps: datePickerProps,
    transformValue,
    utc = true,
    onChangeListener = () => void 0,
    placeholder
  } = props;

  const m = utc ? moment.utc : moment;

  if (utc && transformValue) {
    throw new Error("select one prop: utc or transformValue");
  }

  return (
    <FormField name={name}>
      {(field) => {
        const disabled = props.disabled || field.disabled;

        return (
          <DatePicker
            {...field.fieldProps}
            innerRef={ref}
            name={name}
            label={field.error || label}
            value={field.value ? m(field.value) : null}
            error={field.invalid && !field.disabled}
            placeholder={placeholder}
            fullWidth
            onChange={(v) => {
              if (!v) {
                field.value = null;
                onChangeListener(field.value);
                return;
              }

              if (transformValue) {
                field.value = transformValue(v);
                onChangeListener(field.value);
                return;
              }

              const date = utc ? v.clone().add(v.utcOffset(), "m") : v;
              field.value = date.toDate();
              onChangeListener(field.value);
            }}
            {...datePickerProps}
            disabled={disabled}
          />
        );
      }}
    </FormField>
  );
});

export default Date;
